module.exports = __webpack_public_path__ + "img/benefits-24.48df9f27.svg";